import React, { Component } from "react";
import VMView from "./VMView";
import UIView from "./UIView";

class ScreenView extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className="Screen"
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <span className="ScreenName">{this.props.screen.get("name")}</span>
        <br />
        {this.props.children}
      </div>
    );
  }
}

export default ScreenView;



// WEBPACK FOOTER //
// ./src/components/ScreenView.js